export const recordedContentAPI = {
  course_analytics: {
    list: "host/recorded/analytics/list",
    stats: "host/recorded/analytics/aggregate",
  },
  // type: "forms" | "exams"
  report: (type = "forms") => `host/recorded/${type}/report`,
  responses: "host/recorded/responses",
};
